/**
 * Get content fields for rendering app settings
 * @param {object} app
 * @param {object} appConfigs
 * @returns {Array<object>}
 */
export function getSettingContentModels(app, appConfigs) {
  const settingConfigs = appConfigs.results.filter(
    (config) => config.type === 'setting' && config.values,
  );

  return settingConfigs.map((config) => ({
    ...config.values,
    collection: 'settings',
    root: config.values.name,
    appSettingsField: true,
    app,
  }));
}
